import store from '../configureStore';
import { apiGet, apiPost } from './apiUtil';

export const getJobsForProject = async (projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  return apiGet(`/shake/job?gid=${currentUserGroup}&parent=${projectId}`, {
    headers: header ? { Authorization: header } : undefined,
  });
};

export const getTemplates = async () => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  return apiGet(`/shake/template?gid=${currentUserGroup}`, {
    headers: header ? { Authorization: header } : undefined,
  });
};

export const createJob = async (jobData: Record<string, unknown>) => {
  const {
    project: { header, projectId },
    workspace: { currentUserGroup },
  } = store.getState();
  // Caller-provided project_id wins — store projectId is null outside ProjectPage
  const body = { project_id: projectId, ...jobData, customer_id: currentUserGroup };
  return apiPost(`/shake/add-job?gid=${currentUserGroup}`, {
    headers: header ? { Authorization: header } : undefined,
    body,
  });
};

export const getJob = async (jobId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  return apiGet(`/shake/job?id=${jobId}&gid=${currentUserGroup}`, {
    headers: header ? { Authorization: header } : undefined,
  });
};
